import { usePaletteTheme } from "../../context/paletteTheme"
import { defaultStyles, useTooltipInPortal } from "@visx/tooltip"
import { numberFormatter } from '../../utils/tools'
import useTickers from '../../hooks/useTickers'
import styles from './Graph.module.css'

export default function TreemapGraphTooltipArea({tooltip}) {
    const { tickers } = useTickers()
    const { colors } = usePaletteTheme()
    const { tooltipData, tooltipLeft, tooltipTop } = tooltip
    const { TooltipInPortal } = useTooltipInPortal({
      scroll: true,
      detectBounds: false,
    })

    const bubbleTooltipStyles = {
      ...defaultStyles,
      background: `${colors.dark1}`,
      padding: "8px",
      lineHeight: '1.5',
      border: `1px solid ${colors.dark4}`,
      transitionDuration: '300ms',
      color: colors.textPrimary
    }

    if (tooltipData) {
      const formatNumber = numberFormatter(tooltipData.valueFormat)
      const currentTicker = tickers.find(ticker => tooltipData.ticker === ticker.value)
      return (
        <TooltipInPortal
          top={tooltipTop }
          left={tooltipLeft}
          style={bubbleTooltipStyles}
          offsetLeft={16}
          offsetTop={-20}
        >
          <div className={styles['flex-between']}>
            <div>{tooltipData.name}</div>
          </div>
          <div className={styles['flex-between']}>
          <div>{tooltipData.ticker}</div>
          </div>
          <div style={{color: tooltipData.value < 0 ? colors.stockDown : colors.stockUp }}>
              {formatNumber(tooltipData.value)}            
          </div>
        </TooltipInPortal>
      )
    } else {
      return <></>
    }

}